/* Luna Form – cart drawer-tillägg (upsell + döljer erbjudandet efter midnatt)
   Laddas alltid från snippets/cart-drawer.liquid, så det fungerar även när
   varukorgen var tom när sidan laddades. */

let QtyEvent = null;
try {
  ({ QuantitySelectorUpdateEvent: QtyEvent } = await import('@theme/events'));
} catch (e) {
  QtyEvent = null;
}

let pagar = false;

// Räknar ihop plattan över ALLA rader (Shopify delar upp raden när rabatten slår in)
async function antalIVarukorg(variantId) {
  const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
  return cart.items
    .filter((i) => String(i.variant_id) === String(variantId))
    .reduce((sum, i) => sum + i.quantity, 0);
}

// Reservväg: lägger bara till det som saknas upp till målantalet – aldrig mer
async function reservvag(variantId, mal) {
  try {
    const har = await antalIVarukorg(variantId);
    const saknas = mal - har;
    if (saknas > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: saknas }] }),
      });
    }
  } finally {
    location.reload();
  }
}

document.addEventListener('click', (e) => {
  const knapp = e.target.closest('[data-lf-upsell]');
  if (!knapp) return;
  e.preventDefault();
  if (knapp.disabled || pagar) return;

  pagar = true;
  knapp.disabled = true;
  knapp.textContent = 'Lägger till…';
  const line = parseInt(knapp.dataset.line, 10);
  const mal = parseInt(knapp.dataset.qty, 10);
  const variantId = knapp.dataset.variant;

  if (!QtyEvent) return reservvag(variantId, mal);

  knapp.dispatchEvent(new QtyEvent(mal, line));

  // Säkerhetskontroll efter 3 s: bara om plattorna totalt fortfarande är färre än målet
  setTimeout(async () => {
    try {
      const har = await antalIVarukorg(variantId);
      if (har < mal) return reservvag(variantId, mal);
    } catch (err) {
      /* gör inget – hellre ingen åtgärd än en dubbel */
    } finally {
      pagar = false;
    }
  }, 3000);
});

function tick() {
  // Döljer "Endast idag"-kortet när erbjudandet gått ut
  document.querySelectorAll('[data-lf-slut]').forEach((kort) => {
    if (parseInt(kort.dataset.lfSlut, 10) <= Math.floor(Date.now() / 1000)) kort.remove();
  });
}

tick();
setInterval(tick, 15000);
